import { TransactionTypes } from "@/stores/user-credentials";
import { Button } from "../ui/button";

export const CheckoutButton = ({
  transactionType,
  isLastQuote = false,
  disabled = false,
  isFormSubmitting = false,
  type,
  payoutAmountLabel,
}: {
  transactionType: TransactionTypes;
  isLastQuote?: boolean;
  disabled?: boolean;
  isFormSubmitting: boolean;
  type: HTMLButtonElement["type"];
  payoutAmountLabel?: string;
}) => {
  return (
    <Button
      className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white font-medium py-5 rounded-sm"
      disabled={isFormSubmitting || disabled}
      type={type}
    >
      {isFormSubmitting ? (
        "Processing..."
      ) : (
        <>
          {transactionType === TransactionTypes.SELL &&
            (isLastQuote ? (
              <span className="flex items-center justify-center gap-2">
                <span>Confirm & Get Paid</span>
                {payoutAmountLabel ? (
                  <span className="rounded-full bg-white/20 px-2 py-0.5">
                    {payoutAmountLabel}
                  </span>
                ) : null}
              </span>
            ) : (
              "Next quote"
            ))}
          {transactionType === TransactionTypes.BUY &&
            "Continue to secure checkout"}
        </>
      )}
    </Button>
  );
};
